<template>
  <div class="mdl-grid">

    <div v-if='~isConnectedtoBC()'>
        Not connected to the Ethereum blockchain. Metamask is required.
        <a href='https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn' target="_blank">Install Metamask extension for Google Chrome</a>
      </div>

    <div class="mdl-card mdl-cell mdl-cell--4-col mdl-shadow--2dp" v-if='isConnectedtoBC()'>

      <figure class="mdl-card__media">
        <div style="overflow: hidden; height: 200px">
          <img src="../assets/blockchain.png" style="height: 300px; width: 100%;">
        </div>
      </figure>

      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">Blockchain Status</h2>
      </div>

      <div class="mdl-card__supporting-text">

        <div v-if='~isConnectedtoBC()'>
            Not connected to the Ethereum blockchain. Metamask is required.<br><br>
            <center>
              <img src="../assets/metamask.png" style="width: 50%;"><br>
              <a href='https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn'>Install Metamask extension for Google Chrome</a>
            </center>
        </div>

      </div>
      
    </div>

  </div>
</template>

<script>
import web3Instance from '../utils/web3Instance'
// import Metamask from '@/components/metamask'

export default {
  name: 'MainPage',

  // components: {
  //     Metamask,
  //   },

  methods: {

    isConnectedtoBC () {
      try {
        var accounts = web3Instance.eth.accounts[0]
        } catch (err) {
        console.log(err)
      }
      return typeof accounts !== 'undefined' ? true : false
    },

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



.mdl-card__media {
  margin: 0;
}

.mdl-card__media > img {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/settings-page.vue